// src/layouts/openPages/live/LiveApis.js
import axios from 'axios';

const instance = axios.create({ timeout: 30000 });

// Extract from URL
const urlParams = new URLSearchParams(window.location.search);
const apiKey = urlParams.get('apiKey');
const thingId = urlParams.get('thingId') || urlParams.get('c'); // fallback

let updateCallback = null;
let updateLoop = null;
let motionLoop = null;
let previousLocation = null;
let currentLocation = null;
let nextLocation = null;
let statusCallback = null;

// --- DIRECT PUBLIC POLLING ---
export function startThingUpdatesNoJourney(callback,statusCb) {
  updateCallback = callback;
  statusCallback = statusCb;
  if (updateLoop) clearInterval(updateLoop);

  const fetchLocation = () => {
    if (document.visibilityState === 'hidden') return;

    // REPLACE WITH YOUR PUBLIC ENDPOINT
    const publicEndpoint = `https://v3.dhundhoo.com/vendor/thing/thingtrack`; // Update this with actual endpoint

    instance
      .get(publicEndpoint, {
        params: { apiKey, thingId },
      })
      .then((res) => {
        const loc = res.data;
        if (!loc?.latitude || !loc?.longitude) return;

        previousLocation = currentLocation;
        currentLocation = nextLocation;
        nextLocation = { latitude: loc.latitude, longitude: loc.longitude };

        if (updateCallback) updateCallback(nextLocation);
        const statusMessage = loc.message; 
                          
        if (statusCallback) {
          statusCallback(statusMessage);
        }
        motion();
      })
      .catch((err) => {
        console.warn('Location fetch failed:', err);
        if (statusCallback) {
          statusCallback('Disconnected');
        }
      });
  };

  // Initial fetch
  fetchLocation();
  // Poll every 8 seconds
  updateLoop = setInterval(fetchLocation, 8000);

  return () => {
    if (updateLoop) clearInterval(updateLoop);
    if (motionLoop) clearInterval(motionLoop);
    updateCallback = null;
  };
}

// --- SMOOTH MOTION ---
function motion() {
  if (motionLoop) clearInterval(motionLoop);
  let steps = 0;
  const total = 80; // 8s / 100ms

  motionLoop = setInterval(() => {
    if (!previousLocation || !nextLocation || !updateCallback) {
      clearInterval(motionLoop);
      return;
    }
    if (steps >= total) {
      currentLocation = nextLocation;
      updateCallback(currentLocation);
      clearInterval(motionLoop);
      return;
    }

    const p = steps / total;
    currentLocation = {
      latitude: previousLocation.latitude + (nextLocation.latitude - previousLocation.latitude) * p,
      longitude: previousLocation.longitude + (nextLocation.longitude - previousLocation.longitude) * p,
    };
    updateCallback(currentLocation);
    steps++;
  }, 100);
}

// --- STOP UPDATES ---
export function stopUpdates() {
  if (updateLoop) clearInterval(updateLoop);
  if (motionLoop) clearInterval(motionLoop);
  updateCallback = null;
}

// --- DUMMY getThing (for initial load) ---
export function getThing(callback, error) {
  // Simulate initial position from URL or first poll
  setTimeout(() => {
    callback({
      latest: {
        GPS: {
          location: { latitude: 28.6139, longitude: 77.2090 } // Default to Delhi, India; will be updated
        }
      }
    });
  }, 100);
}